import { render, staticRenderFns } from "./ProfilePoints.vue?vue&type=template&id=74f8a2fe"
import script from "./ProfilePoints.vue?vue&type=script&lang=js"
export * from "./ProfilePoints.vue?vue&type=script&lang=js"
import style0 from "./ProfilePoints.vue?vue&type=style&index=0&id=74f8a2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports